/*
 * nd-claim.js — play the setup clip while it is on screen.
 *
 * Silent, looping, and only while visible. A demonstration of how fast the
 * thing sets up is worth nothing if someone has to ask for it, and worth
 * less than nothing if it downloads for every reader who never scrolls that
 * far -- so the source is only attached when the band comes into view.
 *
 * Anyone who has asked for reduced motion gets the poster frame and a
 * control instead. That is not a fallback, it is the setting being honoured.
 */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-nd-claim-video]').forEach(function (video) {
    if (reduced) {
      video.setAttribute('controls', '');
      video.preload = 'metadata';
      return;
    }

    if (!('IntersectionObserver' in window)) {
      video.setAttribute('controls', '');
      return;
    }

    var watcher = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            /* load() only once: calling it on every scroll back restarts the
               download and the clip. */
            if (video.preload === 'none') {
              video.preload = 'auto';
              video.load();
            }
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.4 }
    );

    watcher.observe(video);
  });
})();
